let redirectStarted = false;

export const handleUnauthorized = () => {
  localStorage.removeItem('user');

  if (!redirectStarted && window.location.pathname !== '/') {
    redirectStarted = true;
    window.location.replace('/');
  }
};

export const fetchWithAuth = (...args) =>
  fetch(...args).then(response => {
    if (response.status === 401) {
      handleUnauthorized();
    }

    return response;
  });
